<template>
    <div class="indexCont">
        <div class="mainCont"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading">
            <div class="btnArr">
                <span @click="goPage('./collect')">
                    <img src="../../../assets/images/common/record1.png" alt="">
                    <div>收藏试题</div>
                </span>
                <span>
                    <img src="../../../assets/images/common/video2.png" alt="">
                    <div>收藏视频</div>
                </span>
            </div>
           <template v-show="!isShow">
                <div class="trainCont">
                    <div class="trainItem" v-for="(item2,index2) in resourceList" :key=index2 >
                        <div class="t_cont">
                            <img :src="$config.baseApi + item2.picUri" alt="">
                            <p class="resourceName">{{item2.courseName}}</p>
                            <p>主讲人：{{item2.teacherName ?item2.teacherName : "暂无"}}</p>
                            <p>学习进度：<el-progress :percentage="parseFloat(item2.process)" :color="customColorMethod" :stroke-width="7" ></el-progress></p>
                        </div>
                        <div class="start">
                            <div class="study" @click="goPage('./trainDetail?id=' + item2.courseId + '&coursename=' + item2.courseName + '&url=collectVideo')">开始学习</div>
                            <div @click="removeItem(item2.courseId)" class="cancle">移除收藏</div>
                        </div>
                    </div>
                </div>
            </template>
            <!-- 没有数据时 -->
            <div class="comTxt" v-show="isShow">暂无数据</div>
        </div>
         <!-- 移动端显示 -->
        <div class="mobileTest">
           <MobileComNav title="我的收藏" url="./index"></MobileComNav>
           <div class="parentCollect">
                <div class="switchTest">
                    <div @click="goPage('./collect')" >收藏试题</div>
                    <div class="active">收藏视频</div>
                </div>
           </div>
        </div>
        <!-- 弹窗 -->
        <el-dialog
            title="提示"
            :visible.sync="centerDialogVisible"
            :width="dialogWidth"
            center>
            <span>是否确定移除收藏</span>
            <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="cancelCollectVideo()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import MobileComNav from "../../../components/mobileHead";
    export default {
        inject:['reload'],
        data(){
            return {
                centerDialogVisible: false,
                dialogWidth: '30%',
                loading:true,
                isShow:false,
                resourceList:"",
                page:1,
                pageSize:10000,
                getCourseId:""
            }
        },
         components: {
            MobileComNav
        },
        mounted(){
            document.title=this.$route.meta.title
        },
        methods: {
            goPage(url){
                this.$router.push(url)
            },
            removeItem(courseId){
                this.centerDialogVisible = true
                this.getCourseId = courseId
            },
            // 取消收藏视频
            cancelCollectVideo(){
                this.$ajax({
                    url:this.$config.baseApi + "/course/favorite/cancel/" + this.getCourseId,
                    method:'post'
                }).then(res=>{  
                    if(res.code == 1){
                        this.centerDialogVisible = false
                        this.$message({
                            message:"已取消收藏",
                            type:'success'
                        })
                        this.videoList()
                    }
                })
            },
            // 获取收藏视频
            videoList(){
                this.isShow = false
                this.$ajax({
                    url:this.$config.baseApi + "/course/favorite/list",
                    method:'post',
                    data:JSON.stringify({
                        page:this.page,
                        pageSize:this.pageSize
                    })
                }).then(res=>{
                    console.log(res)
                    if(res.code == 1){
                        this.loading = false;
                        // 不反data
                        if(res.data.total == 0){
                            this.isShow = true;
                            this.resourceList= []
                        }else{
                            this.resourceList = res.data.records;
                        }
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
            customColorMethod(percentage) {
                if (percentage < 30) {
                    return '#f56c6c';
                } else if (percentage < 70) {
                    return '#e6a23c';
                } else {
                    return '#67c23a';
                }
            },
        },
        created(){
            if(this.$IsPc()){
                // 移动改变弹窗宽度；
                this.dialogWidth = "80%";
            };
            this.videoList()
        }
    }
</script>

<style scoped>
    @import "../../../assets/css/home/home.css";
    .mainCont{
        background: #fff;
        padding:0.23rem 0.2rem;
        position: relative;
        min-height: 4rem;
    }
    .trainCont{
        padding-top:0.1rem;
    }
    .mobileTest{
        display: none;
        margin-top: 1.2rem;
    }
    .comBtn{
        margin-bottom:0.1rem ;
    }
    .btnArr{
        border-bottom: 1px solid #e8e8e8;
        position: relative;
        margin-bottom:20px;
    }
    .btnArr .rank{
        position: absolute;
        top:0;
        right:0;
    }
    .btnArr span{
        display: inline-block;
        height: 0.42rem;
        width:1.2rem;
        line-height: 0.42rem;
        text-align: center;
        cursor: pointer;
    }
    .btnArr span img{
        height: 0.15rem;
    }
    .btnArr span:nth-child(2){
        position: relative;
        border-bottom:0.03rem solid #417ccb;
        color:#417ccb;
    }
    .btnArr span:nth-child(2){
        position: relative;
    }
    .btnArr span div{
        margin-left:0.15rem;
    }
    .btnArr span img{
        height: 0.16rem;
        position: absolute;
        top: 0.13rem;
        left: 0.14rem;
    }
     .t_head .t_txt{
        display: flex;
        justify-content: space-between;
        position: relative;
        font-size:0.2rem;
    }
    .t_head{
        font-size: 0.18rem;
        color:#fff;
        background: linear-gradient(top left, #3780d0, #2ca2db);/*渐变从左上角到右下角*/
        background: -ms-linear-gradient(top left, #3780d0, #2ca2db);
        background: -webkit-linear-gradient(top left, #3780d0, #2ca2db);
        background: -moz-linear-gradient(top left, #3780d0, #2ca2db);
        height: 0.36rem;
        line-height: 0.36rem;
        padding:0 0.2rem ;
    }
    .trainCont{
        background:#fff;
        padding-bottom: 0.1rem;
    }

    .start{
        display:flex;
    }
    .start>div{
        flex:1
    }
    .start .study{
        background:rgba(0, 114, 188, 1);
        color:#fff;
    }
    @media screen and (max-width: 768px) {
        .btnArr{
            display: none;
        }
        .t_head{
            padding:0 0.26rem 0;
            font-size: 0.36rem;
            height: 0.72rem;
            line-height: 0.72rem;
        }
        .t_head .t_txt{
            font-size: 0.32rem;
            position: relative;
        }
        .trainCont{
            padding-bottom: 0.3rem;
        }
        .mainCont {
            margin-top:1.8rem;
            box-sizing: border-box;
            background:transparent;
            padding:0;
            min-height: 8rem;
        }
        .mobileTest {
            display: block;
        }
        .comBtn{
            margin:0.2rem 0;
        }
        .parentCollect{
            position: fixed;
            height:0.9rem;
            padding-top:0.1rem;
            width:100%;
            top:0.8rem;
            left:0;
            background: #f5f5f9;
        }
        .switchTest{
            height: 0.8rem;
            display: flex;
            background: #fff;
            justify-content: space-around;
            align-items: center;
            padding:0 1rem;
            font-size:0.3rem;
            
            box-sizing: border-box;
        }
        .switchTest .active{
            height: 100%;
            border-bottom: 2px solid #417ccb;
            box-sizing: border-box;
            line-height: 0.8rem;
            color:#417ccb;
        }
    }
</style>
